"use strict";

(function( namespace ) {
	/**
	* Retrieve player-id, media-id and article-id attributes from element.
	* @param {object} el - Element to be checked.
	* @returns {object} - Object containing playerId, mediaId and articleId.
	*/
	var getVideoAttributes = function( el ) {
		if ( !el.hasAttribute( "data-player-id" ) ||
			!el.hasAttribute( "data-media-id" ) ||
			!el.hasAttribute( "data-article-id" ) ) {
			return null;
		}

		return {
			playerId: el.getAttribute( "data-player-id" ),
			mediaId: el.getAttribute( "data-media-id" ),
			articleId: el.getAttribute( "data-article-id" ),
		};
	};

	/**
	* Assemble Nitehawk query URL.
	* @param {object} el - Element to be checked.
	* @returns {string}
	*/
	var getNitehawkEndpoint = function( el ) {
		var videoAttr = getVideoAttributes( el );

		if ( !videoAttr.playerId ) {
			return null;
		}

		return namespace.getNitehawkUrl() + "/embeds/" + videoAttr.playerId;
	};

	/**
	* Retrieve file, preview_image, title and source from Nitehawk response.
	* @param {object} responseText - XHR response.
	* @returns {object} - Object containing file, image, title and source.
	*/
	var getVideoData = function( responseText ) {
		var videoData = null;
		var rawSources = [];
		var parsedSources = [];
		var adsDisabledInEmbed = false;

		try {
			videoData = JSON.parse( responseText );
		} catch( e ) {
			videoData = null;
		}

		if ( !videoData ) {
			return parsedSources;
		}

		if ( !videoData.media ) {
			return parsedSources;
		}

		if ( videoData.ads_disabled ) {
			adsDisabledInEmbed = true;
		}

		if ( videoData.media.videos && videoData.media.videos.length > 0 ) {
			rawSources = videoData.media.videos;
		} else {
			rawSources.push( videoData.media );
		}

		for ( var i = 0; i < rawSources.length; i++ ) {
			var source = {};

			if ( !rawSources[ i ] ) {
				continue;
			}

			if ( !rawSources[ i ].transcodings ) {
				continue;
			}

			if ( rawSources[ i ].id ) {
				source.id = rawSources[ i ].id;
			}

			if ( rawSources[ i ].title ) {
				source.title = rawSources[ i ].title;
			}

			if ( rawSources[ i ].preview_image ) {
				source.poster = rawSources[ i ].preview_image;
			}

			if ( rawSources[ i ].type ) {
				source.type = rawSources[ i ].type;
			}

			if ( rawSources[ i ].created_at ) {
				source.createdAt = rawSources[ i ].created_at;
			}

			if ( rawSources[ i ].source ) {
				if ( rawSources[ i ].source.title ) {
					source.source = rawSources[ i ].source.title;
				}

				if ( rawSources[ i ].source.url ) {
					source.sourceUrl = rawSources[ i ].source.url;
				}
			}

			if ( rawSources[ i ].ads_disabled || adsDisabledInEmbed ) {
				source.ads_disabled = true;
			} else {
				source.ads_disabled = false;				
			}

			if ( rawSources[ i ].categories && rawSources[ i ].categories.length > 0 ) {
				if ( rawSources[ i ].categories[ 0 ].title ) {
					source.category = rawSources[ i ].categories[ 0 ].title;
				}
			}

			for ( var j = 0; j < rawSources[ i ].transcodings.length; j++ ) {
				if ( rawSources[ i ].transcodings[ j ] &&
					rawSources[ i ].transcodings[ j ].preset_name &&
					rawSources[ i ].transcodings[ j ].preset_name === "apple_m3u8" ) {
					source.url = rawSources[ i ].transcodings[ j ].full_url;
					break;
				}
			}

			if ( rawSources[ i ].captions ) {
				for ( var k = 0; k < rawSources[ i ].captions.length; k++ ) {
					if ( rawSources[ i ].captions[ k ] &&
						rawSources[ i ].captions[ k ].url &&
						rawSources[ i ].captions[ k ].type &&
						rawSources[ i ].captions[ k ].language &&
						rawSources[ i ].captions[ k ].full_language &&
						rawSources[ i ].captions[ k ].language === "en" &&
						rawSources[ i ].captions[ k ].type === "vtt" ) {
						source.text = {
							url: rawSources[ i ].captions[ k ].url,
							language: rawSources[ i ].captions[ k ].language,
							full_language: rawSources[ i ].captions[ k ].full_language,
						};
						break;
					}
				}
			}

			var fallback480p = null;
			var fallback360p = null;
			var fallback240p = null;
			for ( var l = 0; l < rawSources[ i ].transcodings.length; l++ ) {
				if ( rawSources[ i ].transcodings[ l ] &&
					rawSources[ i ].transcodings[ l ].preset_name &&
					rawSources[ i ].transcodings[ l ].preset_name === "rover_16x9_480p_sd" ) {
					fallback480p = rawSources[ i ].transcodings[ l ].full_url;
				}

				if ( rawSources[ i ].transcodings[ l ] &&
					rawSources[ i ].transcodings[ l ].preset_name &&
					rawSources[ i ].transcodings[ l ].preset_name === "rover_16x9_360p_sd" ) {
					fallback360p = rawSources[ i ].transcodings[ l ].full_url;
				}

				if ( rawSources[ i ].transcodings[ l ] &&
					rawSources[ i ].transcodings[ l ].preset_name &&
					rawSources[ i ].transcodings[ l ].preset_name === "rover_16x9_240p_sd" ) {
					fallback240p = rawSources[ i ].transcodings[ l ].full_url;
				}
			}
			
			if ( fallback240p ) {
				source.fallback = fallback240p;
			}
			if ( fallback360p ) {
				source.fallback = fallback360p;
			}
			if ( fallback480p ) {
				source.fallback = fallback480p;
			}

			if ( source.id && source.url ) {
				parsedSources.push( source );
			}
		}

		return parsedSources;
	};

	/**
	* Query Nitehawk and forward to checkAnime to eventually insert video player inside element.
	* @param {object} el - Element to be checked.
	*/
	namespace.getNitehawkData = function( el ) {
		var videoElId = "lumiere-" + el.getAttribute( "data-player-id" );

		var nitehawkCallback = function( responseText ) {
			var videoData = getVideoData( responseText );

			if ( !videoData || videoData.length === 0 ) {
				videojs.log.error( "failed to retrieve video data for " + videoElId );
				return;
			}

			namespace.checkAnime( el, videoData );
		};

		var nitehawkEndpoint = getNitehawkEndpoint( el );

		if ( !nitehawkEndpoint ) {
			videojs.log.error( "failed to retrieve nitehawk endpoint for " + videoElId );
			return;
		}

		namespace.xhrGet( nitehawkEndpoint, nitehawkCallback );
	};
})( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/nitehawk.js
// module id = 79
// module chunks = 0